"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyLookNameUniqueIn = exports.verifyDashboardNameUniqueIn = exports.verifyFolderNameUniqueIn = exports.filterListofFolderIds = exports.getUniqueListOfReportFolderIds = exports.deleteFolder = exports.updateFolder = exports.createFolder = exports.getFolderLooksFor = exports.getFolderDashboardsFor = exports.verifyEditPermissionForCurrentUser = exports.getFolderChildrenCountForPaging = exports.getAllowedAction = exports.getFolderChildrenSummaries = exports.getFolderAncestorsNoFilter = exports.getFolderAncestors = exports.getFolderFor = exports.getAllEditableFoldersFor = exports.getFolderChildrenByName = exports.getHomePageFolders = void 0;
const folderDto_1 = require("../../dtos/folderDto");
const dashboardDto_1 = require("../../dtos/dashboardDto");
const lookDto_1 = require("../../dtos/lookDto");
const internalAxios_1 = require("./internalAxios");
const reportElementTypes_1 = require("../../domain/reportElementTypes");
const recent_1 = require("./recent");
const content_1 = require("./content");
const getHomePageFolders = async () => {
    const applicationRootFolderId = parseInt(localStorage.getItem('application_root_folder_id') || '0');
    const externalGroupFolderId = parseInt(localStorage.getItem('group_space_id') || '0');
    let homePageFolders = [];
    const [externalGroupFolder, applicationRootFolder] = await Promise.all([
        (0, exports.getFolderFor)(externalGroupFolderId),
        (0, exports.getFolderChildrenSummaries)({ page: 1, perPage: 30 }, applicationRootFolderId),
    ]);
    if (externalGroupFolder) {
        homePageFolders.push(externalGroupFolder);
    }
    if (applicationRootFolder) {
        homePageFolders = [...homePageFolders, ...applicationRootFolder];
    }
    return homePageFolders;
};
exports.getHomePageFolders = getHomePageFolders;
const getFolderChildrenByName = async (folderId, childFolderName, fields) => {
    if (!folderId)
        return;
    const response = await internalAxios_1.internalAxios.post(`/api/folder/${folderId}/children/search`, { fields, name: childFolderName }, {
        params: {
            folderId,
        },
    });
    const { id = '', name = '', parentId = '', child_count: childCount = '', friendly_name: friendlyName = '', } = response.data[0] ?? [];
    return {
        id: parseInt(id),
        name,
        parentId,
        childCount,
        friendlyName,
    };
};
exports.getFolderChildrenByName = getFolderChildrenByName;
const getAllEditableFoldersFor = async () => {
    const externalGroupFolderId = parseInt(localStorage.getItem('group_space_id') || '0');
    const personalFolderId = parseInt(localStorage.getItem('personal_folder_id') || '0');
    const [externalGroupFolder, personalFolder] = await Promise.all([
        (0, exports.getFolderFor)(externalGroupFolderId),
        (0, exports.getFolderFor)(personalFolderId),
    ]);
    const editableFolders = [];
    if (externalGroupFolder?.can?.edit_content) {
        editableFolders.push(externalGroupFolder);
    }
    if (personalFolder?.can?.edit_content) {
        editableFolders.push(personalFolder);
    }
    const descendants = (await Promise.all(editableFolders.map((folder) => getFolderDescendents(folder.id)))).flat();
    return [...editableFolders, ...descendants];
};
exports.getAllEditableFoldersFor = getAllEditableFoldersFor;
const getFolderDescendents = async (folderId) => {
    const children = (await (0, exports.getFolderChildrenSummaries)({ page: 1, perPage: 30 }, folderId)) ??
        [];
    let result = [];
    for (const child of children) {
        if (child) {
            result.push(child);
            const subFolders = (await (0, exports.getFolderChildrenSummaries)({ page: 1, perPage: 30 }, child.id)) ?? [];
            result = [...result, ...subFolders];
        }
    }
    return result;
};
const getFolderFor = async (folderId) => {
    if (!folderId)
        return;
    const { data } = await internalAxios_1.internalAxios.get(`/api/folder/${folderId}`);
    const folderDto = new folderDto_1.FolderDto(data);
    folderDto.name = folderDto.friendlyName;
    return folderDto;
};
exports.getFolderFor = getFolderFor;
const getFolderAncestors = async (folderId) => {
    if (!folderId)
        return;
    const applicationRootFolderName = localStorage.getItem('application_root_folder_name');
    const folders = await internalAxios_1.internalAxios.get(`/api/folder/${folderId}/ancestors`);
    const folderDtos = folders.data
        .map((folder) => new folderDto_1.FolderDto(folder))
        .filter((folder) => folder.name.toLowerCase() !== applicationRootFolderName?.toLowerCase());
    return folderDtos;
};
exports.getFolderAncestors = getFolderAncestors;
const getFolderAncestorsNoFilter = async (folderId) => {
    if (!folderId)
        return;
    const folders = await internalAxios_1.internalAxios.get(`/api/folder/${folderId}/ancestors`);
    const folderDtos = folders.data.map((folder) => new folderDto_1.FolderDto(folder));
    return folderDtos;
};
exports.getFolderAncestorsNoFilter = getFolderAncestorsNoFilter;
const getFolderChildrenSummaries = async ({ page, perPage }, folderId) => {
    if (!folderId)
        return;
    const { data } = await internalAxios_1.internalAxios.get(`/api/folder/${folderId}/children/summaries`, {
        params: { page, perPage },
    });
    return await (0, content_1.syncUserForFolder)(data?.map((folder) => new folderDto_1.FolderDto(folder)));
};
exports.getFolderChildrenSummaries = getFolderChildrenSummaries;
const getAllowedAction = async (folderId) => {
    if (!folderId) {
        return;
    }
    const { data } = await internalAxios_1.internalAxios.get(`/api/folder/${folderId}/allowedAction`);
    return data;
};
exports.getAllowedAction = getAllowedAction;
const getFolderChildrenCountForPaging = async (folderId) => {
    const { data } = await internalAxios_1.internalAxios.get(`/api/folder/${folderId}/children/count`);
    return data.length;
};
exports.getFolderChildrenCountForPaging = getFolderChildrenCountForPaging;
const verifyEditPermissionForCurrentUser = async (folderId) => {
    if (!folderId)
        return false;
    const folder = await (0, exports.getFolderFor)(folderId);
    return folder?.can?.edit_content || false;
};
exports.verifyEditPermissionForCurrentUser = verifyEditPermissionForCurrentUser;
const getFolderDashboardsFor = async (folderId) => {
    if (!folderId)
        return;
    const { data } = await internalAxios_1.internalAxios.get(`/api/folder/${folderId}/dashboards`);
    const dtos = data
        ?.map((dashboard) => {
        return new dashboardDto_1.DashboardDto(dashboard);
    })
        .filter((dashboard) => dashboard.deletedAt === null);
    return dtos.length
        ? await (0, content_1.syncUser)(await (0, recent_1.syncViewCountAndDate)(reportElementTypes_1.ReportElementTypes.Dashboard, dtos))
        : dtos;
};
exports.getFolderDashboardsFor = getFolderDashboardsFor;
const getFolderLooksFor = async (folderId) => {
    if (!folderId)
        return;
    const { data } = await internalAxios_1.internalAxios.get(`/api/folder/${folderId}/looks`);
    const dtos = data
        ?.map((look) => {
        return new lookDto_1.LookDto(look);
    })
        .filter((look) => look.deletedAt === null);
    return dtos.length > 0
        ? await (0, content_1.syncUser)(await (0, recent_1.syncViewCountAndDate)(reportElementTypes_1.ReportElementTypes.Look, dtos))
        : dtos;
};
exports.getFolderLooksFor = getFolderLooksFor;
const createFolder = async (folder) => {
    if (!folder)
        return;
    const { data } = await internalAxios_1.internalAxios.post(`/api/folder`, folder);
    return data;
};
exports.createFolder = createFolder;
const updateFolder = async (folderId, folder) => {
    if (!folderId || !folder) {
        return;
    }
    const { data } = await internalAxios_1.internalAxios.patch(`/api/folder/${folderId}`, folder);
    return data;
};
exports.updateFolder = updateFolder;
const deleteFolder = async (folderId) => {
    if (!folderId) {
        return;
    }
    const { status } = await internalAxios_1.internalAxios.delete(`/api/folder/${folderId}`);
    return status === 200;
};
exports.deleteFolder = deleteFolder;
const getUniqueListOfReportFolderIds = (reports) => {
    const folderIds = [];
    reports.forEach((report) => {
        if (!folderIds.includes(report.folder.id)) {
            folderIds.push(report.folder.id);
        }
    });
    return folderIds;
};
exports.getUniqueListOfReportFolderIds = getUniqueListOfReportFolderIds;
const filterListofFolderIds = async (folderIds) => {
    try {
        const folderKeepIndex = [];
        let localStorageNullCheck = localStorage.getItem('group_space_id');
        const orgFolderId = parseInt(localStorageNullCheck !== null ? localStorageNullCheck : '0');
        localStorageNullCheck = localStorage.getItem('personal_folder_id');
        const personalFolderId = parseInt(localStorageNullCheck !== null ? localStorageNullCheck : '0');
        localStorageNullCheck = localStorage.getItem('application_root_folder_id');
        const appFolder = parseInt(localStorageNullCheck !== null ? localStorageNullCheck : '0');
        if (orgFolderId === 0 || personalFolderId === 0 || appFolder === 0) {
            throw new Error('Application context not detected');
        }
        folderKeepIndex.push(orgFolderId);
        folderKeepIndex.push(personalFolderId);
        for (const id of folderIds) {
            if (id !== personalFolderId && id !== orgFolderId) {
                const folderAncestors = await (0, exports.getFolderAncestorsNoFilter)(id);
                const filteredAncestors = folderAncestors?.map((ancestors) => ancestors.id);
                if (filteredAncestors?.includes(appFolder) ||
                    filteredAncestors?.includes(personalFolderId) ||
                    filteredAncestors?.includes(orgFolderId)) {
                    folderKeepIndex.push(id);
                }
            }
        }
        return folderKeepIndex;
    }
    catch (e) {
        console.error(e);
    }
};
exports.filterListofFolderIds = filterListofFolderIds;
const verifyFolderNameUniqueIn = async (folderName, parentFolderId) => {
    const duplicateFolder = await (0, exports.getFolderChildrenByName)(parentFolderId, folderName);
    return duplicateFolder?.name === '';
};
exports.verifyFolderNameUniqueIn = verifyFolderNameUniqueIn;
const verifyDashboardNameUniqueIn = async (dashboardName, parentFolderId) => {
    const folderDashboards = await (0, exports.getFolderDashboardsFor)(parseInt(parentFolderId));
    const duplicateDashboard = folderDashboards?.find((dashboard) => dashboard.title.trim().toLowerCase() ===
        dashboardName.trim().toLocaleLowerCase());
    return !duplicateDashboard;
};
exports.verifyDashboardNameUniqueIn = verifyDashboardNameUniqueIn;
const verifyLookNameUniqueIn = async (lookName, parentFolderId) => {
    const folderLooks = await (0, exports.getFolderLooksFor)(parseInt(parentFolderId));
    const duplicateLook = folderLooks?.find((look) => look.title.trim().toLowerCase() === lookName.trim().toLocaleLowerCase());
    return !duplicateLook;
};
exports.verifyLookNameUniqueIn = verifyLookNameUniqueIn;
